<template>
  <div class="profile-volunteering">
    <div class="profile-volunteering__content">
      <gray-block class="volunteering-info">
        <volunteering-stat :amount="volunteering.length" />
        <hr />
        <volunteering-calendar :volunteering="volunteering" />
      </gray-block>

      <profile-table-layout
        title="Мероприятия"
        :get-items="api.volunteeringPeriod.events"
        entity="events"
      >
        <template #table-item="slotProps">
          <volunteering-event-item :item="slotProps.item" />
        </template>
      </profile-table-layout>

      <!--gray-block class="volunteering-sport">
        <h4>Спорт</h4>

        <white-block class="volunteering-item">
          <h3>Международные соревнования по лыжным гонкам</h3>
          <p>15-25 января 2024, г. Ханты-Мансийск</p>
          <p class="info"><b>Результат:</b> победитель</p>
        </white-block>

        <white-block class="volunteering-item">
          <h3>Международные соревнования по лыжным гонкам</h3>
          <p>15-25 января 2024, г. Ханты-Мансийск</p>
          <p class="info"><b>Результат:</b> победитель</p>
        </white-block>
      </gray-block-->
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useStore } from 'vuex';
  import VolunteeringStat from '@/components/profile/volunteering/VolunteeringStat.vue';
  import VolunteeringCalendar from '@/components/profile/volunteering/VolunteeringCalendar.vue';
  import GrayBlock from '@/components/blocks/GrayBlock.vue';
  // import WhiteBlock from '@/components/blocks/WhiteBlock.vue';
  import dayjs from 'dayjs';
  import ProfileTableLayout from '@/components/profile/ProfileTableLayout.vue';
  import VolunteeringEventItem from '@/components/profile/volunteering/VolunteeringEventItem.vue';

  const api = useApi();
  const store = useStore();
  const volunteering = ref([]);

  const prepareVolunteeringItem = (item) => {
    for (let i = 0; i < item.days; i++) {
      const firstDay = dayjs(item.startedAt);
      //const lastDay = dayjs(item.endedAt);
      const day = firstDay.add(i, 'day').format('YYYY-MM-DD');
      const k = volunteering.value.findIndex((item) => item.date === day);

      if (-1 === k) {
        volunteering.value.push({
          date: day,
          value: 1,
        });
      } else {
        volunteering.value[k].value++;
      }
    }
  };

  const getVolunteering = async () => {
    if (!store.state.person.id) return;

    try {
      let response = [];
      let p = 1,
        t = 1,
        l = 0;

      do {
        response = await api.volunteeringPeriod.index({
          personId: store.state.person.id,
          status: 2,
          page: p,
        });

        l = response.periods.items.length;
        for (let i = 0; i < l; i++) {
          prepareVolunteeringItem(response.periods.items[i]);
        }

        p++;
        t = response.periods.pages.total ?? 0;
      } while (p <= t);
    } catch (error) {
      // TODO: добавить обработку ошибок
      console.log(error);
    }
  };

  onMounted(() => {
    getVolunteering();
  });

  watch(
    () => store.state.person.id,
    () => {
      getVolunteering();
    }
  );
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .profile-volunteering {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &__content {
      margin-bottom: 200px;
    }
  }

  .volunteering-info {
    margin-bottom: 20px;

    hr {
      margin: 35px 0 20px 0;
      background: #aeb4dd;
    }
  }

  .volunteering-events,
  .volunteering-sport {
    margin-bottom: 10px;
    width: 100%;

    .volunteering-item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      h3 {
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 10px 0;
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        margin: 0 0 15px 0;

        &.info {
          color: #718096;
          margin: 0;

          b {
            font-weight: 700;
          }
        }
      }
    }
  }
</style>
